import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import MessagesListPage from '../components/MessagesListPage'
import {
  actionCreators,
  IMessagesListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectShowArchived,
  selectTotalItems,
} from '../modules/messagesList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IMessagesListState & ICurrentUserState
  >({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    showArchived: selectShowArchived(),
    totalItems: selectTotalItems(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(MessagesListPage)
